/* eslint-disable react-hooks/exhaustive-deps */

import { useCallback, useState } from "react";
import { decimalRound } from "../utils/featureAnalysisUtils";


const usePositionAndMaterial = (setFeatureValueList, setscenarioFeatures) => {

    const [featureList, setFeatureList] = useState([]);
    const [positionOption, setPositionOptions] = useState(null);
    const [materialOption, setMaterialOptions] = useState(null);
    const [changeFeatureList, setChangeFeatureList] = useState(null);

    const setPositionAndMaterial = useCallback((data1, removeTarget) => {
        const removePM = removeTarget.filter((obj) => {
            if (
                Object.keys(obj)[0].startsWith("Position") ||
                Object.keys(obj)[0].startsWith("Material")
            )
                return false;
            return true;
        });

        const ftrList = removePM.map((obj) => Object.keys(obj)[0]);
        setFeatureList(ftrList);

        const positionList = data1.filter((obj) =>
            Object.keys(obj)[0].startsWith("Position")
        );
        const materialList = data1.filter((obj) =>
            Object.keys(obj)[0].startsWith("Material")
        );
        const fValue = removePM?.map((obj) => decimalRound(Object.values(obj)[0], Object.keys(obj)[0]));
        if (positionList?.length > 0) {
            const positionData = positionList.filter(
                (obj) =>
                    Object.keys(obj)[0].startsWith("Position") &&
                    Object.values(obj)[0] === 1
            );
            if (positionData?.length > 0) {
                const positionValue =
                    positionData?.length > 0
                        ? Object.keys(positionData[0])[0].slice(8)
                        : "";
                fValue.push(positionValue);
                removePM.push({ Position: positionValue });
                setPositionOptions(
                    positionList.map((ele) => Object.keys(ele)[0].slice(8))
                );
            }
        }

        if (materialList?.length > 0) {
            const materialData = materialList.filter(
                (obj) =>
                    Object.keys(obj)[0].startsWith("Material") &&
                    Object.values(obj)[0] === 1
            );

            if (materialData?.length > 0) {
                const materialValue =
                    materialData.length > 0
                        ? Object.keys(materialData[0])[0].slice(8)
                        : "";
                fValue.push(materialValue);
                removePM.push({ Material: materialValue });
                setMaterialOptions(
                    materialList.map((ele) => Object.keys(ele)[0].slice(8))
                );
            }
        }

        setFeatureValueList(fValue);
        setscenarioFeatures([...removePM]);
        setChangeFeatureList([...removeTarget]);
    }, []);

    return { featureList, positionOption, materialOption, changeFeatureList, setPositionAndMaterial }
}

export default usePositionAndMaterial;